<template>
  <div id="app">
    <NavComponent />
    <b-col cols="4">
      <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 12px; padding: 10px 0 10px 12px;">
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">숨김</small>
          <b-dropdown
            id="dropdown-1"
            :text="dropdownHideFilterType"
            :variant="dropdownHideFilterType !== 'all' ? 'info' : 'secondary'"
            size="sm"
          >
            <b-dropdown-item @click="changeHideCategoryFilterDropbox('all')">all</b-dropdown-item>
            <b-dropdown-item @click="changeHideCategoryFilterDropbox('none')">none</b-dropdown-item>
            <b-dropdown-item @click="changeHideCategoryFilterDropbox('전체숨김')">전체숨김</b-dropdown-item>
            <b-dropdown-item @click="changeHideCategoryFilterDropbox('신고누적숨김')">신고누적숨김</b-dropdown-item>
            <b-dropdown-item @click="changeHideCategoryFilterDropbox('작외숨')">작외숨</b-dropdown-item>
          </b-dropdown>
        </div>
        <span class="text-muted">|</span>
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">삭제</small>
          <b-dropdown
            id="dropdown-is-delete"
            :text="dropdownIsDeleteFilter"
            :variant="dropdownIsDeleteFilter !== 'all' ? 'info' : 'secondary'"
            size="sm"
          >
            <b-dropdown-item @click="changeIsDeleteFilter('all')">all</b-dropdown-item>
            <b-dropdown-item @click="changeIsDeleteFilter('삭제됨')">삭제됨</b-dropdown-item>
            <b-dropdown-item @click="changeIsDeleteFilter('삭제안됨')">삭제안됨</b-dropdown-item>
          </b-dropdown>
        </div>
        <span class="text-muted">|</span>
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">삭제 유형</small>
          <b-dropdown
            id="dropdown-deleted-by"
            :text="deletedByFilterLabel"
            :variant="selectedDeletedByFilters.length > 0 ? 'info' : 'secondary'"
            size="sm"
          >
            <b-dropdown-form>
              <b-form-checkbox-group
                v-model="selectedDeletedByFilters"
                :options="deletedByOptions"
                stacked
                @change="onDeletedByFilterChange"
              ></b-form-checkbox-group>
            </b-dropdown-form>
          </b-dropdown>
        </div>
        <span class="text-muted">|</span>
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">유형</small>
          <b-dropdown
            id="dropdown-content-type"
            :text="dropdownContentTypeFilter"
            :variant="dropdownContentTypeFilter !== 'all' ? 'info' : 'secondary'"
            size="sm"
          >
            <b-dropdown-item @click="changeContentTypeFilter('all')">all</b-dropdown-item>
            <b-dropdown-item @click="changeContentTypeFilter('일반')">일반</b-dropdown-item>
            <b-dropdown-item @click="changeContentTypeFilter('사진')">사진</b-dropdown-item>
            <b-dropdown-item @click="changeContentTypeFilter('영상')">영상</b-dropdown-item>
            <b-dropdown-item @click="changeContentTypeFilter('음성')">음성</b-dropdown-item>
            <b-dropdown-item @click="changeContentTypeFilter('GIF')">GIF</b-dropdown-item>
          </b-dropdown>
        </div>
        <span class="text-muted">|</span>
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">검색</small>
          <b-dropdown id="dropdown-search-type" :text="dropdownSearchType" size="sm">
            <b-dropdown-item @click="changeDropboxSearchType('email')">email</b-dropdown-item>
            <b-dropdown-item @click="changeDropboxSearchType('callRoom')">callRoom</b-dropdown-item>
            <b-dropdown-item @click="changeDropboxSearchType('text')">text</b-dropdown-item>
          </b-dropdown>
          <b-input-group size="sm" style="width: 200px;">
            <b-form-input
              v-model="keyword"
              placeholder="검색어 입력"
              @keyup.enter="getCommentByEmail()"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="info" :disabled="!keyword.trim()" @click="getCommentByEmail()">
                Search
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <b-button
          v-if="isFilterActive"
          variant="outline-danger"
          size="sm"
          class="ml-1"
          @click="getDefaultSearch()"
        >
          초기화
        </b-button>
      </div>
      <div
        style="display: flex; justify-content: flex-start; margin-left: 10px"
      >
        <b-p v-if="isSearch">
          {{ dropdownSearchType }}: "{{ searchedKeyword }}" 로 검색한
          결과입니다.</b-p
        >
      </div>
    </b-col>
    <b-col>
      <div style="display: flex; width: 100%; justify-content: flex-start; align-items: center; gap: 12px; padding: 10px 0 10px 12px;">
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">숨김 처리</small>
          <b-dropdown id="dropdown-hide-action" :text="dropdownHideType" size="sm">
            <b-dropdown-item @click="changeDropboxHideType('none')">none</b-dropdown-item>
            <b-dropdown-item @click="changeDropboxHideType('전체숨김')">전체숨김</b-dropdown-item>
            <b-dropdown-item @click="changeDropboxHideType('신고누적숨김')">신고누적숨김</b-dropdown-item>
            <b-dropdown-item @click="changeDropboxHideType('작외숨')">작외숨</b-dropdown-item>
          </b-dropdown>
          <b-button variant="warning" size="sm" :disabled="selectedCommentIds.length === 0" @click="hideActionButton()">
            적용
          </b-button>
        </div>
        <span class="text-muted">|</span>
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">신고</small>
          <b-dropdown id="dropdown-report-action" :text="dropdownReportType" size="sm">
            <b-dropdown-item v-for="text in feedReasonList" :key="text" @click="changeDropboxReportType({ text })">{{text}}</b-dropdown-item>
          </b-dropdown>
          <b-button variant="danger" size="sm" :disabled="selectedCommentIds.length === 0" @click="createReportButton()">
            신고
          </b-button>
        </div>
      </div>
    </b-col>
    <b-row>
      <b-col cols="12">
        <b-table
          hover
          :items="commentList"
          :fields="commentTableFields"
          small
          :tbody-tr-class="commentRowClass"
          style="cursor: pointer;"
          @row-clicked="(item) => commentCheckboxChange(item.comment.comment_id)"
        >
          <template #head(user.uuid)>
            <b-form-checkbox
              :checked="isAllCommentsSelected"
              @change="toggleSelectWholeComments()"
            />
          </template>
          <template #cell(user.uuid)="row">
            <b-form-checkbox
              :checked="selectedComments[row.item.comment.comment_id] === 'accepted'"
              name="checkbox-1"
              @change="commentCheckboxChange(row.item.comment.comment_id)"
            >
            </b-form-checkbox>
          </template>

            <template #cell(comment.is_delete)="row">
          <b-icon :icon="row.item.comment.is_delete ? 'check-circle' : 'x-circle'" :variant="row.item.comment.is_delete ? 'success' : 'danger'"></b-icon>
        </template>
          <template #cell(comment.deleted_by)="row">
            <b-badge v-if="row.item.comment.deleted_by === 'USER'" variant="secondary">본인</b-badge>
            <b-badge v-else-if="row.item.comment.deleted_by === 'ADMIN'" variant="danger">관리자</b-badge>
            <b-badge v-else-if="row.item.comment.deleted_by === 'SYSTEM_WITHDRAWAL'" variant="dark">회원탈퇴</b-badge>
            <span v-else>-</span>
          </template>
          <template #cell(comment.comment_id)="row">
            <b-button
              size="sm"
              class="mr-2"
              @click="
                openFeedComment(row.item.user.uuid, row.item.comment.comment_id)
              "
            >
              VIEW
            </b-button>
          </template>

          <template #cell(id)="row">
            <b-button
              class="mr-2"
              size="sm"
              style="width: 100px; word-break: break-all"
              @click="openFeedComment(row.item.user.data.uuid, row.item.id)"
            >
              {{ row.item.id }}
            </b-button>
          </template>

          <template #cell(comment.feedpost_id)="row">
            <b-button
              class="mr-2"
              size="sm"
              @click="
                openFeedContent(row.item.comment.feedpost_id, row.item.comment)
              "
              style="width: 100px; word-break: break-all"
            >
              VIEW
            </b-button>
          </template>

          <template #cell(user.email)="row">
            <b-button
              class="mr-2"
              size="sm"
              @click="openAdminUserPage(row.item.user.email)"
              style="width: 100px; word-break: break-all"
            >
              {{ row.item.user.email }}
            </b-button>
          </template>
          <template>

          </template>
          <template #cell(comment.created_at)="row">
            {{ getTimeStamp(row.item.comment.created_at) }}
          </template>
          <template #cell(commentPreview)="row">
            <div
              v-if="row.item.comment.content.type === 'IMAGE' && row.item.comment.content.url && row.item.comment.content.url.length > 0"
              style="display: flex; overflow-x: auto; gap: 4px; max-width: 200px; cursor: pointer;"
              @click.stop="openPreviewModal(row.item.comment.content.url)"
            >
              <b-img
                v-for="(img, idx) in row.item.comment.content.url"
                :key="idx"
                :src="img.url"
                :alt="row.item.comment.content.text || '댓글 이미지 미리보기'"
                style="height: 80px; width: auto; flex-shrink: 0;"
              />
            </div>
            <audio
              v-else-if="row.item.comment.content.type === 'AUDIO' && row.item.comment.content.url && row.item.comment.content.url.length > 0"
              controls
              preload="none"
              :src="row.item.comment.content.url[0].url"
              :aria-label="row.item.comment.content.text || '댓글 음성 미리보기'"
              style="max-width: 200px"
            ></audio>
          </template>
          <template #cell(comment.content.text)="row">
            <div style="width: 300px; word-break: break-all">
              <template v-if="row.item.comment.content.text && row.item.comment.content.text.length > 50">
                {{ row.item._textExpanded
                  ? row.item.comment.content.text
                  : row.item.comment.content.text.substring(0, 50) + '...' }}
                <b-link @click.stop="$set(row.item, '_textExpanded', !row.item._textExpanded)">
                  {{ row.item._textExpanded ? '접기' : '더보기' }}
                </b-link>
              </template>
              <template v-else>
                {{ row.item.comment.content.text }}
              </template>
            </div>
          </template>
          <template #cell(comment.mentioned_user.email)="row">
            
            
            <b-button
              v-if="row.item.comment.mentioned_user.email"
              class="mr-2"
              size="sm"
              @click="openAdminUserPage(row.item.comment.mentioned_user.email)"
              style="width: 100px; word-break: break-all"
            >
              {{ row.item.comment.mentioned_user.email }}
            </b-button>

          </template>
        </b-table>
      </b-col>

      <!-- <b-col cols="6">
                <h5>
                    <b-badge>대댓글</b-badge>
                </h5>
                <b-table 
                    hover 
                    :items="bigCommentList" 
                    :fields="bigCommentTableFields"
                    small
                    table-layout: fixed
                >
                    <template #cell(comment.feedpost_id)="row">
                        <b-button 
                            class="mr-2"
                            size="sm"
                            @click="openFeedContent(row.item.comment.feedpost_id, row.item.comment)" 
                            style="width: 100px; word-break: break-all"
                        >
                            글 이동
                        </b-button>
                    </template>
                    
                    <template #cell(id)="row">
                        <b-button 
                            class="mr-2"
                            size="sm"
                            style="width: 100px; word-break: break-all"
                            @click="openFeedComment(row.item.user.data.uuid, row.item.id)"
                        >
                            {{row.item.id}}
                        </b-button>
                    </template>
                    <template #cell(user.email)="row">
                        <b-button 
                            class="mr-2"
                            size="sm"
                            @click="openAdminUserPage(row.item.user.email)" 
                            style="width: 100px; word-break: break-all"
                        >
                        {{row.item.user.email}}
                        </b-button>
                    </template>
                    <template #cell(comment.created_at)="row">
                        {{getTimeStamp(row.item.comment.created_at)}}
                    </template>
                </b-table>
                <b-button @click="getBigCommentByEmail()" :disabled="bigCommentNext==''">
                    MORE
                </b-button>
            </b-col> -->
    </b-row>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li
          class="page-item"
          v-for="item in createPageArray()"
          v-bind:key="item"
        >
          <a
            :style="[
              isPageButtonActive(item) ? { 'background-color': '#EC9E8E' } : {},
            ]"
            class="page-link"
            href="#"
            v-on:click="getComments(item)"
            >{{ item }}</a
          >
        </li>
      </ul>
    </nav>
    <ImagePreviewModal modalId="commentPreviewModal" :images="previewImages" />
  </div>
</template>

<script>
import NavComponent from "./NavComponent.vue";
import ImagePreviewModal from "./ImagePreviewModal.vue";

export default {
  name: "FeedCommentSearch",
  components: {
    NavComponent,
    ImagePreviewModal,
  },
  data() {
    return {
      previewImages: [],
      tmp: [],

      commentList: [],
      commentTableFields: [
        { key: "user.uuid", label: "" },
        {
          key: "comment.comment_id",
          label: "Comment ID",
        },
        {
          key: "user.email",
          label: "email",
        },
        {
          key: "comment.content_type",
          label: "content type",
        },
        {
          key: "comment.content.text",
          label: "text",
          thStyle: { width: "300px" },
        },
        {
          key: "commentPreview",
          label: "미리보기",
        },
       
        {
          key: "comment.total_count_likes",
          label: "좋아요",
        },
        {
          label: "대댓글",
          key: "comment.total_count_comments",
        },
        {
          label: "멘션된 유저",
          key: "comment.mentioned_user.email",
        },
        {
          key: "comment.total_count_reports",
          label: "신고",
        },
        {
          key: "comment.is_delete",
          label: "삭제",
        },
        {
          key: "comment.deleted_by",
          label: "삭제 유형",
        },
        {
          key: "comment.hide",
          label: "숨김",
        },
        {
          key: "comment.created_at",
          label: "created_at",
        },


      ],
      bigCommentList: [],
      bigCommentTableFields: [
        {
          key: "comment.feedpost_id",
          label: "FeedPost ID",
        },
        {
          key: "comment.comment_id",
          label: "Comment ID",
        },
        {
          key: "user.email",
          label: "email",
        },
        {
          key: "comment.content.type",
          label: "contentType",
        },
        {
          key: "comment.content.text",
          label: "content",
        },
        {
          key: "comment.hide",
          label: "hide",
        },
        "comment.created_at",
      ],
      feedReasonList: ["none"],
      keyword: "",
      searchUserUuid: "",
      commentNext: null,
      bigCommentNext: null,
      loginCountry: this.$session.get("country"),
      apiBaseUrl: "",
      page: 0,
      bigPage: 0,
      isSearch: false,
      dropdownHideType: "none",
      dropdownReportType: "none",
      dropdownSearchType: "email",
      searchedKeyword: "",
      dropdownHideFilterType: 'all',
      dropdownIsDeleteFilter: 'all',
      dropdownContentTypeFilter: 'all',
      selectedDeletedByFilters: [],
      deletedByOptions: [
        { text: '본인', value: 'USER' },
        { text: '관리자', value: 'ADMIN' },
        { text: '회원탈퇴', value: 'SYSTEM_WITHDRAWAL' },
      ],
      hideCategory: {
        "none": "NONE",
        "전체숨김": "CS",
        "신고누적숨김": "REPORT",
        "작외숨": "OWN"
      },
      reportType: {
        "none": "NONE",
      },
      selectedComments: {}
    };
  },
  computed: {
    isAllCommentsSelected() {
      return this.commentList.length > 0 && this.selectedCommentIds.length === this.commentList.length;
    },
    selectedCommentIds() {
      return Object.keys(this.selectedComments).filter(
        (key) => this.selectedComments[key] === "accepted"
      );
    },
    deletedByFilterLabel() {
      if (this.selectedDeletedByFilters.length === 0) return 'all';
      const labelMap = { USER: '본인', ADMIN: '관리자', SYSTEM_WITHDRAWAL: '회원탈퇴' };
      return this.selectedDeletedByFilters.map(v => labelMap[v]).join(', ');
    },
    isFilterActive() {
      return this.dropdownHideFilterType !== 'all'
        || this.dropdownIsDeleteFilter !== 'all'
        || this.dropdownContentTypeFilter !== 'all'
        || this.selectedDeletedByFilters.length > 0
        || this.isSearch;
    },
  },
  beforeMount() {
    this.apiBaseUrl = process.env.VUE_APP_FEED_SERVICE_URL;
    this.getComments(this.page);
    this.getReasonKey();
  },
  methods: {
    openPreviewModal(images) {
      this.previewImages = images;
      this.$bvModal.show('commentPreviewModal');
    },
    commentRowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.comment.total_count_reports >= 1) return 'table-warning'
    },
    commentCheckboxChange(comment_id) {
      if (this.selectedComments[comment_id] === 'accepted') {
        this.$delete(this.selectedComments, comment_id)
      } else {
        this.$set(this.selectedComments, comment_id, 'accepted')
      }
    },
    getTimeStamp(created_at) {
      return this.$moment(created_at).format("YY/MM/DD HH:mm");
    },
    getHeader() {
      return {
              Authorization: this.$session.get("token"),
              uuid: this.$session.get("uuid"),
            }
    },
    createPageArray() {
      let list = [];

      let b = parseInt(this.page / 10);
      let f = false;
      for (var i = 0; i < 12; i++) {
        if (b >= 1 && !f) {
          f = true;
          list.push(b * 10 + i - 1);
        }
        list.push(b * 10 + i);
      }

      return list;
    },

    changeHideCategoryFilterDropbox(value) {
      this.dropdownHideFilterType = value
      this.getComments(0)
    },
    changeIsDeleteFilter(value) {
      this.dropdownIsDeleteFilter = value
      this.getComments(0)
    },
    changeContentTypeFilter(value) {
      this.dropdownContentTypeFilter = value
      this.getComments(0)
    },
    onDeletedByFilterChange() {
      this.getComments(0)
    },
    isPageButtonActive(currentP) {
      return currentP == this.page ? true : false;
    },
    openAdminUserPage(email) {
      window.open(
        `${process.env.VUE_APP_DJANGO_URL}/ko/yp/manage/service/admin/account/user/by-email/?email=${email}`
      );
    },
    changeDropboxHideType(value) {
      this.dropdownHideType = value;
    },
    changeDropboxReportType(value) {
      this.dropdownReportType = value.text;
    },
    changeDropboxSearchType(value) {
      this.dropdownSearchType = value;
    },
    async getDefaultSearch() {
      this.dropdownSearchType = "email";
      this.dropdownHideFilterType = "all";
      this.dropdownIsDeleteFilter = "all";
      this.dropdownContentTypeFilter = "all";
      this.selectedDeletedByFilters = [];
      this.searchedKeyword = "";
      this.keyword = "";
      this.isSearch = false;
      this.page = 0;
      this.getComments(this.page);
    },
    createUrl(page) {
      let apiURL = "";
      const baseUrl = `${this.apiBaseUrl}/management/comments/search`
      const queryParams = new URLSearchParams();
      if (page) {
          queryParams.append('page', page)
      } else {
        queryParams.append('page', 0)
      }

      if (this.dropdownHideFilterType != 'all') {
        queryParams.append('hide[0]', this.hideCategory[this.dropdownHideFilterType])
      }

      // isDelete 필터
      if (this.dropdownIsDeleteFilter !== 'all') {
        const isDeleteValue = this.dropdownIsDeleteFilter === '삭제됨' ? 'true' : 'false'
        queryParams.append('isDelete', isDeleteValue)
      }

      // contentType 필터
      const contentTypeMap = {
        '일반': 'NORMAL',
        '사진': 'IMAGE',
        '영상': 'VIDEO',
        '음성': 'AUDIO',
        'GIF': 'GIF',
      }
      if (this.dropdownContentTypeFilter !== 'all') {
        const mappedContentType = contentTypeMap[this.dropdownContentTypeFilter]
        if (mappedContentType) {
          queryParams.append('contentType[0]', mappedContentType)
        }
      }

      // deletedBy 필터
      this.selectedDeletedByFilters.forEach(value => {
        queryParams.append('deletedBy', value)
      })

      if (this.isSearch) {
        const keyword = this.keyword.trim();
        switch (this.dropdownSearchType) {
          case "email":
            queryParams.append('email', keyword);
            break;
          case "callRoom":
            queryParams.append('callRoomId', keyword);
            break;
          case "text":
            queryParams.append('text', keyword);
            break;
        }
        apiURL = `${baseUrl}?${queryParams.toString()}`
      } else {
        apiURL = `${this.apiBaseUrl}/management/comments/by-country?${queryParams.toString()}`;
      }
      return apiURL
    },
  getComments(p) {
      const url = this.createUrl(p)
      this.$http
        .get(url, {
          headers: {
            Authorization: this.$session.get("token"),
            uuid: this.$session.get("uuid"),
          },
        })
        .then((res) => {
          const comments = res.data.data.comments;
          
          if (res.status === 200) {
            this.page = p;

            let items = [];

            for (let it of comments) {
              if (!it){
                continue
              }

              const comment = it.comment;
              
              
              switch (comment.access) {
                case "PUBLIC":
                  comment.access = "전체";
                  break;
                case "PRIVATE":
                  comment.access = "팔로우";
                  break;
              }

              switch (comment.hide) {
                case "CS":
                  comment.hide = "전체숨김";
                  break;
                case "REPORT":
                  comment.hide = "신고누적숨김";
                  break;
                case "OWN":
                  comment.hide = "작외숨";
                  break;
                case "NONE":
                  comment.hide = "none";
                  break;
              }

              switch (comment.content.type) {
                case "IMAGE":
                  comment.content_type = "사진";
                  break;
                case "AUDIO":
                  comment.content_type = "음성";
                  break;
                case "CALL_ROOM":
                  comment.content_type = "룸공유";
                  break;
                case "NORMAL":
                  comment.content_type = "일반";
                  break;
                
                
              }
              
      

              items.push(it);
              }
            
            this.commentList = items;
          }
        })
        .catch((err) => {
          console.log(err)
          alert(err);
        });
    },
    async getCommentByEmail() {
      if (this.keyword === "") {
        return
      }
      if (!this.isSearch) {
        this.page = 0;
        this.isSearch = true;
      }
      this.searchedKeyword = this.keyword.trim();
      this.getComments(this.page);
    },
    async getBigCommentByEmail() {
      await this.$http
        .get(
          `${this.apiBaseUrl}/management/comments/re/search?page=${
            this.bigPage
          }&email=${this.keyword.trim()}`,
          {
            headers: {
              Authorization: this.$session.get("token"),
              uuid: this.$session.get("uuid"),
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            if (this.searchUserUuid != res.data.data.uuid) {
              // this.bigCommentList = []
              // this.bigCommentNext = null
            }
            this.bigCommentList = [
              ...this.bigCommentList,
              ...res.data.data.comments,
            ];
            this.bigPage++;

            this.searchUserUuid = res.data.data.uuid;
          }
        })
        .catch((err) => {
          alert(err);
        });

     
    },
    async getReasonKey() {
      this.$http
      .get(process.env.VUE_APP_API + "/management/report/control_reasons/", {
        params: { domain: "COMMENT" },
        headers: { Authorization: this.$session.get("token") },
      })
      .then((res) => {
        if (res.status === 200) {
          // 서버가 위치별 활성 사유를 도메인맵 순서대로 내려주므로 그대로 쓴다
          res.data.data.forEach((reason) => {
            let translatedText = "";
            switch (this.loginCountry){
              case "EN":
                translatedText = reason.description_en;
                break;
              case "JP":
                translatedText = reason.description_ja;
                break;
              default:
                translatedText = reason.description_ko;
                break;
            }
            this.feedReasonList.push(translatedText);
            this.reportType[translatedText] = reason.key;
          });
        }
      })
      .catch((err) => {
        alert("report reasons Error" + err);
      });
    },

    openFeedComment(userId, commentId) {
      const routeData = this.$router.resolve({
        name: "feedComment",
        params: { user_id: userId, comment_id: commentId },
      });
      window.open(routeData.href, "_blank");
    },

    openFeedContent(feed_id, feed) {
      const routeData = this.$router.resolve({
        name: "feedContent",
        params: { id: feed_id, feed: feed },
      });
      window.open(routeData.href, "_blank");
    },
    toggleSelectWholeComments() {
      if (this.selectedCommentIds.length === this.commentList.length) {
        this.selectedComments = {};
      } else {
        const nextSelected = {};
        this.commentList.forEach((item) => {
          nextSelected[item.comment.comment_id] = "accepted";
        });
        this.selectedComments = nextSelected;
      }
    },
    async hideActionButton() {
      await this.$http
        .put(
          `${this.apiBaseUrl}/management/comments/batch`,
          {
            commentIds: this.selectedCommentIds,
            data: {
              hide: this.hideCategory[this.dropdownHideType],
            },
          },
          {
            headers:this.getHeader()
          }
        )
        .then((res) => {
          if (res.status === 200) {
            alert("success");
            this.selectedComments = {};
            this.getComments(this.page);
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    async createReportButton() {
     
      if(this.reportType[this.dropdownReportType] == "NONE"){
        alert("신고 사유를 선택해주세요");
      } else if(this.selectedCommentIds.length>1) {
        alert("한개의 댓글만 선택해주세요");
      } else {
        const selectedId = String(this.selectedCommentIds[0]);
        const selectedComment = this.commentList.find(
          (comment) => String(comment.comment.comment_id) === selectedId
        );
        const userUUID = selectedComment ? selectedComment.user.uuid : "";
        if (!userUUID) {
          alert("선택한 댓글 작성자 정보를 찾을 수 없습니다.");
          return;
        }
        await this.$http
        .post(`${process.env.VUE_APP_API}/report/v4/report`, {
          "reason_key": this.reportType[this.dropdownReportType],
          "report_content": "관리자 신고",
          "domain": "COMMENT",
          "obj_id": this.selectedCommentIds[0]
        }, {
          headers: {
            'Authorization': this.$session.get('token'),
            'Remote-user': userUUID
          }
        }).then((res) => {
          if(res.status === 201) {
            alert("success");
            this.selectedComments = {};
            this.getComments(this.page);
          }else if(res.status === 200) {
            alert("이미 관리자 신고처리 된 데이터입니다");
          }
        }).catch((err) => {
          alert(err);
        })
      }
    },
  },
};
</script>
